import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const ArubaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14303'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14303)'>
				<g filter='url(#filter0_d_2332_14303)'>
					<rect
						width='20'
						height='14'
						fill='#4189DD'
					/>
				</g>
				<path
					d='M4.11022 1.71409L3.81173 1.15349L3.51324 1.71409L3.07234 2.54213L2.2274 2.9742L1.65536 3.26672L2.2274 3.55924L3.07234 3.99132L3.51324 4.81936L3.81173 5.37996L4.11022 4.81936L4.55111 3.99132L5.39605 3.55924L5.96809 3.26672L5.39605 2.9742L4.55111 2.54213L4.11022 1.71409Z'
					fill='#D21034'
					stroke='white'
					strokeWidth='0.666667'
				/>
				<rect
					y='10.2667'
					width='20'
					height='0.933333'
					fill='#F9D616'
				/>
				<rect
					y='8.40002'
					width='20'
					height='0.933333'
					fill='#F9D616'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_14303'
					x='-1'
					y='0'
					width='22'
					height='16'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='1' />
					<feGaussianBlur stdDeviation='0.5' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_14303'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_14303'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default ArubaFlagIcon;
